type PermittedField = {
  value?: unknown
}

type JobWithPermittedFields = {
  permittedFields?: Record<string, PermittedField | undefined>
}

export type PermittedJobLanguage = {
  index?: number
  language?: string
  languageDescription?: string
}

export type PermittedJobSkill = {
  name?: string
  description?: string
  requirementType?: string
  level?: {
    id: number
    name: string
  }
}

export const getPermittedFieldValue = <T>(
  job: JobWithPermittedFields | undefined,
  field: string,
  fallback?: T
): T | undefined => {
  const value = job?.permittedFields?.[field]?.value
  // TODO_REMOVE_PERMITTED_FIELDS_FALLBACK: remove fallback after all job APIs return these fields only in permittedFields.
  return (value ?? fallback) as T | undefined
}

export const getPermittedFieldName = (
  job: JobWithPermittedFields | undefined,
  field: string,
  fallback?: string
) => {
  const value = getPermittedFieldValue<unknown>(job, field)
  if (typeof value === 'string') return value
  if (value && typeof value === 'object' && 'name' in value) {
    return String((value as { name?: unknown }).name ?? fallback ?? '')
  }
  return fallback
}
